/**
 * 拦截器管理器
 * 管理拦截器的添加、执行和移除
 */
class InterceptorManager {
  constructor () {
    this.interceptors = []
  }

  /**
   * 添加拦截器
   * @param {Function} onFulfilled - 成功处理函数
   * @param {Function} [onRejected] - 错误处理函数
   * @returns {Function} 移除该拦截器的函数
   * 添加拦截器到拦截器链中
   * onFulfilled：拦截器成功处理函数，接收配置或响应对象
      onRejected：拦截器错误处理函数
   */
  use (onFulfilled, onRejected) {
    const interceptor = {
      onFulfilled: typeof onFulfilled === 'function' ? onFulfilled : (v) => v,
      onRejected: typeof onRejected === 'function' ? onRejected : (e) => Promise.reject(e)
    }

    this.interceptors.push(interceptor)

    // 返回移除函数
    return () => {
      const index = this.interceptors.indexOf(interceptor)
      if (index !== -1) {
        this.interceptors.splice(index, 1)
      }
    }
  }

  /**
   * 执行所有拦截器
   * @param {*} initialValue - 初始值
   * @returns {Promise} 处理后的值
   * 按顺序执行所有拦截器
   * initialValue：初始值（请求配置或响应对象）
   */
  async run (initialValue) {
    let currentValue = initialValue

    for (const interceptor of this.interceptors) {
      try {
        currentValue = await interceptor.onFulfilled(currentValue)
      } catch (error) {
        currentValue = await interceptor.onRejected(error)
      }
    }

    return currentValue
  }

  /**
   * 清空所有拦截器
   */
  clear () {
    this.interceptors = []
  }

  /**
   * 获取当前拦截器数量
   * @returns {number} 拦截器数量
   */
  size () {
    return this.interceptors.length
  }
}

export default InterceptorManager
